import { useDocFlowCommunicationSettings } from '../../DocFlow.hooks'
import { DocFlowSendingWidgetProcessFieldName } from '../../DocFlowSending'
import { DocFlowSendingWidgetContent } from '../DocFlowSendingWidgetContent'

function DocFlowSendingCommunicationSettingsWidget({ index, ...restProps }) {
  const { handleClickNext, isError, notifications } =
    useDocFlowCommunicationSettings({ index })

  return (
    <DocFlowSendingWidgetContent
      {...restProps}
      index={index}
      isError={isError}
      notifications={notifications}
      widgetStatusFieldName={
        DocFlowSendingWidgetProcessFieldName.CommunicationSettingsPhase
      }
      onSubmit={handleClickNext}
    />
  )
}

export default DocFlowSendingCommunicationSettingsWidget
